import { render, staticRenderFns } from "./CountrySection.vue?vue&type=template&id=5c2dad96&scoped=true"
import script from "./CountrySection.vue?vue&type=script&lang=js"
export * from "./CountrySection.vue?vue&type=script&lang=js"
import style0 from "./CountrySection.vue?vue&type=style&index=0&id=5c2dad96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2dad96",
  null
  
)

export default component.exports